<template>
  <div
    v-if="actionType"
    class="job-architecture-row-actions d-flex align-center ga-2"
  >
    <DpplNewButton
      v-if="!isProfile"
      class="text-button-3 text-textDarkest bg-white"
      variant="outlined"
      height="32"
      min-width="0"
      @click.stop="handleRename"
    >
      Rename
    </DpplNewButton>
    <template v-if="isFamily">
      <DpplNewButton
        class="text-button-3 text-textDarkest bg-white"
        variant="outlined"
        height="32"
        min-width="0"
        @click.stop="handleMove"
      >
        Move
      </DpplNewButton>
      <DpplNewButton
        class="text-button-3 text-error bg-white"
        variant="outlined"
        height="32"
        min-width="0"
        @click.stop="handleDelete"
      >
        Delete
      </DpplNewButton>
      <DpplNewButton
        v-if="hasProfiles"
        variant="text"
        color="brandPrimary"
        height="32"
        min-width="0"
        class="text-button-3 px-2"
        @click.stop="emit('toggle-selection')"
      >
        {{ allSelected ? 'Deselect all profiles' : 'Select all profiles' }}
      </DpplNewButton>
    </template>
    <template v-if="isProfile">
      <DpplNewButton
        class="text-button-3 text-textDarkest bg-white"
        variant="outlined"
        height="32"
        min-width="0"
        @click.stop="handleProfileMove"
      >
        Move
      </DpplNewButton>
      <DpplNewButton
        v-if="hasFamily"
        class="text-button-3 text-error bg-white"
        variant="outlined"
        height="32"
        min-width="0"
        @click.stop="handleProfileRemove"
      >
        Remove
      </DpplNewButton>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';
import { useJobArchitecture } from '@/stores/jobArchitecture/jobArchitecture';

const props = defineProps({
  item: { type: Object, default: () => ({}) },
  allSelected: { type: Boolean, default: false },
});

const emit = defineEmits(['toggle-selection']);

const { openRowAction, loadJobFamilyOptions } = useJobArchitecture();

const isGroup = computed(() => props.item.nodeType === 'group' && props.item.ulid);
const isFamily = computed(() => props.item.nodeType === 'family' && props.item.ulid);
const isProfile = computed(() => props.item.nodeType === 'profile' && props.item.ulid);
const actionType = computed(() => isGroup.value || isFamily.value || isProfile.value);
const hasProfiles = computed(() => (props.item.children?.length ?? 0) > 0);
const hasFamily = computed(() => Boolean(props.item.familyUlid));

const buildNode = () => ({
  ulid: props.item.ulid,
  name: props.item.name,
  groupUlid: props.item.groupUlid ?? null,
  profileCount: props.item.profileCount ?? 0,
  draftCount: props.item.draftCount ?? null,
});

const buildProfileNode = () => ({
  ulid: props.item.ulid,
  name: props.item.title,
});

const handleRename = () => {
  openRowAction(isFamily.value ? 'rename-family' : 'rename-group', buildNode());
};

const handleMove = () => {
  openRowAction('move-family', buildNode());
};

const handleDelete = () => {
  openRowAction('delete-family', buildNode());
};

const handleProfileMove = async () => {
  await loadJobFamilyOptions();
  await openRowAction('move-profile', buildProfileNode());
};

const handleProfileRemove = () => {
  openRowAction('remove-profile', buildProfileNode());
};
</script>
